import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase-config';

export const removeFromFavorites = async (userEmail, auctionId) => {
  const removeFromFavoritesFn = httpsCallable(functions, 'removeFromFavoritesV2');
  try {
    const result = await removeFromFavoritesFn({
      userEmail,
      auctionId,
      requestedApp: 'reseller_app',
    });
    return result.data;
  } catch (error) {
    console.error('Error removing from favorites:', error);
    return { success: false, error: error.message };
  }
};
